import { Box } from '@mui/material'

export function FormWrapper({ children }: { children: React.ReactNode }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      {children}
    </Box>
  )
}
